import {SQFTResourceController} from "./SQFTResourceController";
import {WORKSPACE_RESOURCES} from "../../../../constants";
import workspace from "../../core/workspace";


export class WallsController extends SQFTResourceController {

  constructor(props) {
    super(props);
    this.resourceName = WORKSPACE_RESOURCES.walls;
  }

  getWallByPoint(searchPoint) {
    return workspace.walls.find(wall => {
      for (const wallPoint of wall.getPoints()) {
        if (wallPoint.id === searchPoint.id) {
          return wall
        }
      }
    })
  }

}

